import { createSelector } from '@ngrx/store';

import { productRestrictionsState } from '../root';

export const getProductsRestrictionsData = createSelector(productRestrictionsState, (productRestrictions) => productRestrictions.data);
